import * as actionTypes from "../actionTypes";
import {
  Item,
  card_action_params,
  cartInitialState,
  service_types
} from "../reducers/cart";

export const addToCart = (item: Item): card_action_params => ({
  type: actionTypes.ADD_TO_CART,
  payload: item
});

export const clearCart = (ignoreAnalytics?: boolean): card_action_params => ({
  type: actionTypes.CLEAR_CART,
  payload: ignoreAnalytics
});

export const removeFromCart = (
  id: number,
  item_type: service_types
): card_action_params => {
  return {
    type: actionTypes.REMOVE_FROM_CART,
    payload: { id, type: item_type }
  };
};

export const removeExtrasFromCart = (): card_action_params => ({
  type: actionTypes.REMOVE_EXTRAS_FROM_CART
});

export const changeCartItem = (item: Item): card_action_params => ({
  type: actionTypes.CHANGE_CART_ITEM,
  payload: item
});

export const setEntireCart = (items: cartInitialState): card_action_params => ({
  type: actionTypes.SET_ENTIRE_CART,
  payload: items
});
